import { Modal, TextInput } from "components/common";
import TextEditor from "components/common/textEditor/textEditor";
import React, { useState } from "react";
import { useSelector } from "react-redux";

const FeedbackModal = ({ question, showModal, setShowModal, onSubmit }) => {
  const user = useSelector((state) => state.app.user.info);
  const [feedbackData, setFeedbackData] = useState({
    title: "",
    description: "",
    userId: user?.user_code,
  });

  const onAddFeedback = async () => {
    let feedback = [];
    if (question?.questionDetails?.feedback?.length) {
      feedback = question?.questionDetails?.feedback;
    }
    feedback = feedback?.length ? [...feedback, feedbackData] : [feedbackData];
    onSubmit(
      {
        ...question?.questionDetails,
        feedback: feedback,
      },
      "feedback"
    );
  };

  return (
    <Modal
      visible={showModal}
      onCancel={() => {
        setShowModal(false);
        setFeedbackData({
          title: "",
          description: "",
        });
      }}
      title="Feedback"
      onOk={onAddFeedback}
      destroyOnClose
    >
      <div>
        <TextInput
          placeholder={"Add Title"}
          value={feedbackData?.title}
          onChange={(e) => {
            setFeedbackData((prev) => ({ ...prev, title: e?.target?.value }));
          }}
          style={{ marginBottom: "15px" }}
        />
        <TextEditor
          style={{ textAlign: "left" }}
          key={"DescriptionFeedback"}
          value={feedbackData?.description}
          onChange={(e) => {
            setFeedbackData((prev) => ({ ...prev, description: e }));
          }}
          placeholder={"Add description"}
          editorHeight={200}
        />
      </div>
    </Modal>
  );
};

export default FeedbackModal;
